// API Configuration for Deployment
const API_BASE_URL = process.env.NODE_ENV === 'production' 
  ? 'https://backend-deploy-twxy.onrender.com' // Your deployed backend domain
  : 'http://localhost:5000'; // Local development

export const API_ENDPOINTS = {
  leads: `${API_BASE_URL}/api/leads`,
  test: `${API_BASE_URL}/api/test`
};
